export default function () {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;
  const $widget = $(`#${widgetName}`);

  const addVideoTag = true;
  const tagText = 'Watch';

  $widget.append('<iframe></iframe>');
  $widget.wrap('<div id="videoSection"></div>');

  $widget.videoWidget({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    detectIpad: IPADDETECTED,
    multiVideo: false,
    showOnMobile: true,
    maxVideos: 1,
    autoPlayVideo: false,

    videoWidgetLoaded: function (data) {
      if (data.Slides.length >= 1 && addVideoTag) {
        $('#videoSection').append(`<div class="video-tag">${tagText}</div>`);
        $('.video-seo-container').addClass('with-video');
        $('.tier-three').css({
          display: 'block',
          opacity: '1',
        });

        $widget.addClass('animate-hidden');
        const observer = new IntersectionObserver(
          (entries, obs) => {
            const entry = entries[0];
            if (entry.isIntersecting) {
              setTimeout(() => {
                $widget.addClass('visible');
              }, 100);
              obs.unobserve(entry.target);
            }
          },
          { threshold: 0.3 },
        );

        observer.observe($widget[0]);
      } else {
        $('#videoSection').remove();
        $('.video-seo-container').addClass('no-video');
      }
    },
  });
}
